<template>
    <form ref="search" id="search" class="col-8 form-inline my-2 my-lg-0">
        <input class="col-12 form-control mr-sm-6 sb-search-input" type="text" placeholder="Search">
    </form>
</template>

<script>

    export default {
        name: "search-bar",
        data() {
            return {
                accentMap: {
                    'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'ý': 'y',
                    'A': 'a', 'É': 'e', 'Í': 'i', 'Ó': 'o', 'Ú': 'u', 'Ý': 'y',
                    'č': "c", 'š': 's', 'ľ': 'l', 'ť': 't', 'ž': 'z', 'ň': 'n',
                    'Č': "c", 'Š': 's', 'Ľ': 'l', 'Ť': 't', 'Ž': 'z', 'Ň': 'n'
                }
            };
        },
        props: {},
        created() {
            let vm = this;

            jQuery(document).ready(function(){
                // jQuery(vm.$refs.search).autocomplete({
                jQuery("#search input").autocomplete({
                    serviceUrl: laroute.route('json.search'),
                    groupBy: 'category',
                    onSelect: function (suggestion) {
                        window.location = suggestion.data.url;
                    },
                    formatResult: function (suggestion, currentValue) {
                        return '<a href="' + suggestion.data.url + '">' +
                            vm.accent_folded_hilite(suggestion.value, currentValue) +
                            '</a>';
                    }
                });

            });

        },
        methods: {
            accent_fold(s) {
                if (!s) {
                    return '';
                }
                let ret = '';
                for (let i = 0; i < s.length; i++) {
                    ret += this.accentMap[s.charAt(i)] || s.charAt(i);
                }
                return ret;
            },
            accent_folded_hilite(str, q) {
                let str_folded = this.accent_fold(str).toLowerCase()
                    .replace(/[<>]+/g, '');
                let q_folded = this.accent_fold(q).toLowerCase()
                    .replace(/[<>]+/g, '');  // Create an intermediate string with hilite hints
                // Example: fulani<lo> <lo>pez
                let re = new RegExp(q_folded, 'g');
                let hilite_hints = str_folded.replace(re,
                    '<' + q_folded + '>');  // Index pointer for the original string
                let spos = 0;
                // Accumulator for our final string
                let highlighted = '';  // Walk down the original string and the hilite hint
                // string in parallel. When you encounter a < or > hint,
                // append the opening / closing tag in our final string.
                // If the current char is not a hint, append the equiv.
                // char from the original string to our final string and
                // advance the original string's pointer.
                for (let i = 0; i < hilite_hints.length; i++) {
                    let c = str.charAt(spos);
                    let h = hilite_hints.charAt(i);
                    if (h === '<') {
                        highlighted += '<strong>';
                    } else if (h === '>') {
                        highlighted += '</strong>';
                    } else {
                        spos += 1;
                        highlighted += c;
                    }
                }
                return highlighted;
            }


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Header/SearchBar.vue